import React from "react";
import { Avatar, Box, Stack, Typography } from "@mui/material";
import { useRouter } from "next/router";
import Superconnect from "../common/Superconnect";
import { trackEvent } from "../../utils/analytics";
import { Verified } from "@mui/icons-material";
import VerifiedBadge from "../chfeed/VerifiedBadge";
import ChampionBadge from "../common/ChampionBadge";
import { analyticsConstants } from "../../constants";

type FeedMemberCardPropsType = {
  memberId: string;
  name: string;
  image: string;
  headline: string;
  connected?: boolean;
  from?: string;
  showScButton?: boolean;
  isVip: boolean;
  champion: string;
  trackingParams?: any;
  withTitle?: boolean;
};

function FeedMemberCard({
  memberId,
  name,
  image,
  headline,
  connected,
  from,
  showScButton = true,
  isVip,
  champion,
  trackingParams,
  withTitle = false,
}: FeedMemberCardPropsType) {
  const router = useRouter();

  const navigateToProfilePage = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.stopPropagation();
    e.preventDefault();
    if (from === "sc") {
      trackEvent("member_profile_card_click", {
        screen_name: analyticsConstants.SCREEN.SEARCH_RESULTS_PAGE,
        tab_name: analyticsConstants.TAB.NETWORK,
        element_name: "member_profile",
        element_type: analyticsConstants.TYPE.CARD,
        event_category: analyticsConstants.CATEGORY.CLICK,
        member_id: memberId,
        member_name: name,
      });
      window?.open(`/profile/${memberId}`, "_blank")!.focus();
    } else if (from === "search") {
      trackEvent("click_profilepage", { pages: "search" });
      window?.open(`/profile/${memberId}`, "_blank")!.focus();
    } else {
      router.push(`/profile/${memberId}`);
    }
  };

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        mt={2}
        sx={{ cursor: "pointer" }}
      >
        <Stack
          direction="row"
          alignItems="flex-start"
          sx={{
            width: "90%",
          }}
          onClick={(e) => navigateToProfilePage(e)}
        >
          <Box mt={0.5}>
            <Avatar
              src={image}
              alt="name"
              sx={{ height: "36px", width: "36px" }}
            />
          </Box>
          <Box ml={0.8}>
            <Stack direction="row" alignItems="center">
              <Typography fontSize={13} color="secondary" fontWeight={500}>
                {name}
              </Typography>
              {isVip && <VerifiedBadge isVerified={isVip} />}
            </Stack>
            <Typography
              sx={{
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: 1,
                display: "-webkit-box",
              }}
              fontSize={11}
              fontWeight={400}
              color="secondary"
            >
              {headline}
            </Typography>

            <ChampionBadge
              isChampion={champion?.length > 0}
              champion={champion}
            />
          </Box>
        </Stack>
        {showScButton && (
          <Superconnect
            withTitle={withTitle}
            isConnected={connected!}
            otherUserId={memberId}
            otherUserName={name}
            from={from}
            trackingParams={trackingParams}
          />
        )}
      </Stack>
    </>
  );
}

export default FeedMemberCard;
